import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

import requestsStore from './requestsStore';

export interface RequestTypeInfo {
  code: string;
  name: string;
  meta: RequestTypeMeta;
}
export interface RequestTypeMeta {
  elements: RequestTypeMetaElement[];
}
export interface RequestTypeMetaElement {
  name: string;
  description: string;
  visualType: 'TextBox' | 'TextArea' | 'SingleListBox' | 'MultiListBox';
}

export interface RequestResourceInfo {
  code: string;
  description: string;
}

export interface RequestModel {
  requestId: string;
  userId: string;
  userName: string;
  companyId: string | null;
  companyName: string;

  requestTypeCode: string;
  requestTypeName: string;

  requestStatus: 'Done' | 'Processing' | 'Error';
  requestStatusName: string;

  requestContent: string;
  description: string;

  responseContent: string;
  isWatched: boolean;
  requestCount: number;
  responseDate: Date;
  createDate: Date;
  errorContent: string;
}

//{"items":[{"order":0,"type":{"name":"Request","propertyName":"request"},"code":"passport","name":null,"value":"Справка \"Полный технический паспорт\"","items":[{"order":0,"type":{"name":"Group","propertyName":"group"},"code":"wagonData","name":null,"value":"Данные о вагоне: 53385027","items":[{"order":0,"type":{"name":"Field","propertyName":"field"},"code":"adm","name":"Администрация собственника","value":"PЖД(20)","items":null},{"order":1,"type":{"name":"Field","propertyName":"field"},"code":"buildDate","name":"Построен","value":"2009-12-26","items":null},{"order":2,"type":{"name":"Field","propertyName":"field"},"code":"owner","name":"Собственник","value":"АО \"БСК\"(203312)","items":null},{"order":3,"type":{"name":"Field","propertyName":"field"},"code":"factory","name":"Изготовитель","value":"АО \"УК \"БМЗ\"(9)","items":null},{"order":4,"type":{"name":"Field","propertyName":"field"},"code":"factoryNumber","name":"Заводской номер","value":"7171","items":null},{"order":5,"type":{"name":"Field","propertyName":"field"},"code":"wagonType","name":"Тип вагона","value":"Хоппер крытый 4-осный для перевозки минеральных удобрений(5931)","items":null},{"order":6,"type":{"name":"Field","propertyName":"field"},"code":"wagonModel","name":"Модель вагона","value":"19-3054-01(516)","items":null},{"order":7,"type":{"name":"Field","propertyName":"field"},"code":"regDate","name":"Дата регистрации","value":"2022-01-20","items":null},{"order":8,"type":{"name":"Field","propertyName":"field"},"code":"endDate","name":"Срок службы","value":"2035-12-26","items":null}]},{"order":1,"type":{"name":"Group","propertyName":"group"},"code":"common","name":null,"value":"Общие данные о вагоне","items":[{"order":0,"type":{"name":"Field","propertyName":"field"},"code":"tara","name":"Тара","value":"226","items":null},{"order":1,"type":{"name":"Field","propertyName":"field"},"code":"carrying","name":"Грузоподъемность","value":"710","items":null}

export interface RecursiveSvp {
  items: RecursiveSvp[];
  order: number;
  type: {
    name: 'Request' | 'Group' | 'Field' | 'MergedGroup';
    propertyName: 'request' | 'group' | 'field' | 'mergedGroup';
  };
  code: string;
  name: string;
  value: string;
}

export const recursiveSpvCodes = ['spv4664', 'spv4714', 'spk4651', 'spv4666', 'spv4702'];

export const getDs = new DataSource({
  store: new CustomStore({
    key: 'requestid',
    load: function (loadOptions) {
      return requestsStore
        .loadData(loadOptions)
        .then((data) => {
          return data;
        })
        .catch(() => {
          throw 'Data Loading Error';
        });
    },
  }),
});
